// extracted by mini-css-extract-plugin
export default {"content":"NoTickets_content__vFJwB","content__title":"NoTickets_content__title__Lj1Ol","content__description":"NoTickets_content__description__cgO7h"};